<template src="./template.html"></template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'Modal',
    computed: {
      ...mapState('modal', ['type']),
      ...mapState('cart', ['addressBook']),
      ...mapGetters('modal', ['isVisible']),
    },
    watch: {
      isVisible() {
        if (this.isVisible) {
          this.toggleHtmlClass('no-scrl', 'addClass')
          this.toggleBodyClass('has-mdl', 'addClass')
        } else {
          this.toggleHtmlClass('no-scrl')
          this.toggleBodyClass('has-mdl')
        }
      },
    },
    mounted() {
      if (!window.document.querySelector('#start > #modal-vue')) {
        window.document.querySelector('#start > #modal-vue')
      }

      if (window.document.getElementById('start')) {
        window.document.getElementById('start').append(window.document.getElementById('modal-vue'))
      }
    },
    methods: {
      ...mapMutations('invoiceAddress', {
        setInvoiceAddress: 'SET_INVOICE_ADDRESS',
      }),
      ...mapMutations('deliveryAddress', {
        setDeliveryAddress: 'SET_DELIVERY_ADDRESS',
      }),
      ...mapMutations('modal', {
        setModalVisibility: 'SET_VISIBILITY',
      }),
      changeAddress(e, address) {
        e.preventDefault()
        if (this.type) {
          this[`set${this.type}`](this.cleanSource(address))
        }
        this.setModalVisibility()
      },
    },
  }
</script>

<style scoped>
  /* mdl-ctrl -> modal-control */
  .mdl-ctrl {
    display: none;
  }
</style>
